"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBirthdate = void 0;
var react_1 = require("react");
var useFormattedMessages_1 = __importDefault(require("./useFormattedMessages"));
var schemas_1 = require("../validation/schemas");
var useBirthdate = function (birthdate) {
    var messages = (0, useFormattedMessages_1.default)('form.birthDatePicker');
    var generateDays = function (daysCount) { return __spreadArray([{
            // Default "Day" empty value
            label: messages.day,
            value: '',
        }], Array(daysCount).fill(undefined).map(function (v, index) { return ({
        label: (index + 1).toString(),
        value: (index + 1).toString(),
    }); }), true); };
    var daysByMonths = (0, react_1.useState)(function () { return [31, 30, 29, 28].map(generateDays); })[0];
    var _a = (0, react_1.useState)(daysByMonths[0]), days = _a[0], setDays = _a[1];
    var months = (0, react_1.useState)(function () { return __spreadArray([{
            // Default "Month" empty value
            label: messages.month,
            value: '',
        }], ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']
        .map(function (month, index) { return ({
        label: messages["months.".concat(month)],
        value: (index + 1).toString(),
    }); }), true); })[0];
    var years = (0, react_1.useState)(function () { return __spreadArray([{
            // Default "Year" empty value
            label: messages.year,
            value: '',
        }], Array(schemas_1.maxBirthDateYear - schemas_1.minBirthDateYear).fill(undefined).map(function (v, index) { return ({
        label: (schemas_1.maxBirthDateYear - index).toString(),
        value: (schemas_1.maxBirthDateYear - index).toString(),
    }); }), true); })[0];
    (0, react_1.useEffect)(function () {
        var yearAsNumber = Number(birthdate.year);
        var monthAsNumber = Number(birthdate.month);
        if (!monthAsNumber || [1, 3, 5, 7, 8, 10, 12].includes(monthAsNumber)) {
            setDays(daysByMonths[0]);
            // February month of leap year case
        }
        else if (yearAsNumber && monthAsNumber === 2 && ((yearAsNumber % 4 === 0 && yearAsNumber % 100 !== 0) || yearAsNumber % 400 === 0)) {
            setDays(daysByMonths[2]);
            // February month of none leap year case
        }
        else if (monthAsNumber === 2) {
            setDays(daysByMonths[3]);
            // 30 days months case
        }
        else {
            setDays(daysByMonths[1]);
        }
    }, [birthdate]);
    return {
        days: days,
        months: months,
        years: years,
    };
};
exports.useBirthdate = useBirthdate;
exports.default = exports.useBirthdate;
